module.exports = {"attributes":{"width":"10px","height":"10px","viewBox":"0 0 10 10","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"},"content":"<g>         <rect transform=\"translate(4.949747, 4.949747) rotate(-225.000000) translate(-4.949747, -4.949747) \" x=\"-1.05025253\" y=\"3.94974747\" width=\"12\" height=\"2\"></rect>         <rect transform=\"translate(4.949747, 4.949747) rotate(-495.000000) translate(-4.949747, -4.949747) \" x=\"-1.05025253\" y=\"3.94974747\" width=\"12\" height=\"2\"></rect>     </g>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/delete.svg
// module id = 1396
// module chunks = 0